module.exports = __webpack_public_path__ + "img/tfboys.65f8727e.jpg";